import { useMsal } from "@azure/msal-react";
import { AzureADRoles } from "./auth-roles";

export const useAccess = (role: string) => {
	const { instance } = useMsal();
	const activeAccount = instance.getActiveAccount();
	const roles = activeAccount?.idTokenClaims!['roles'] ?? [];

	return hasRole(roles, role, false);
}

export const useAccountId = () => {
	const { instance } = useMsal();
	const activeAccount = instance.getActiveAccount();
	return activeAccount?.localAccountId ?? "";
}

export const useAccountRoles = () => {
	const { instance } = useMsal();
	const activeAccount = instance.getActiveAccount();
	return activeAccount?.idTokenClaims!['roles'] ?? [];
}

export const hasRole = (roles: string[], role: string, exact: boolean) => {
	switch (role) {
		case AzureADRoles.All:
			return roles.includes(AzureADRoles.Admin) || roles.includes(AzureADRoles.FullUser) || roles.includes(AzureADRoles.Requester);
		case AzureADRoles.AdminOrFullUser:
			return roles.includes(AzureADRoles.Admin) || roles.includes(AzureADRoles.FullUser);
		case AzureADRoles.Requester:
			return exact ? roles.includes(AzureADRoles.Requester) : roles.includes(AzureADRoles.Admin) || roles.includes(AzureADRoles.FullUser) || roles.includes(AzureADRoles.Requester);
		case AzureADRoles.FullUser:
			return exact ? roles.includes(AzureADRoles.FullUser) : roles.includes(AzureADRoles.Admin) || roles.includes(AzureADRoles.FullUser);
		case AzureADRoles.Admin:
			return roles.includes(AzureADRoles.Admin);
	}
	return false;
}

export const isInRole = (roles: string[], role: string) => { 
	return roles.find(r => r === role) !== undefined;
}